export default {"src":"/_next/static/image/public/images/ic_manage_family_grey_vertical_menu.5160543cad2bf5b544c26df993a19c3c.svg","height":20,"width":20};